import { render, staticRenderFns } from "./TemplateCompare.vue?vue&type=template&id=76a9d638&"
import script from "./TemplateCompare.vue?vue&type=script&lang=js&"
export * from "./TemplateCompare.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCompare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports